/**
 * SamVision Cabinet — web entry point.
 *
 * Mirrors index.js exactly, but boots via react-native-web's AppRegistry against a DOM
 * root instead of the native bridge. Registers the SAME root component (`App`) under the
 * SAME app name as native, so App.tsx and everything under it is untouched.
 *
 * The two extra jobs here are the ones that only exist in a browser: hand the boot
 * splash over to React, and register the service worker that makes the app installable
 * and openable offline.
 *
 * @format
 */
import {AppRegistry} from 'react-native';
import App from './App';
import {name as appName} from './app.json';
import {registerServiceWorker} from './src/shared/lib/pwa';

AppRegistry.registerComponent(appName, () => App);

AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
});

/**
 * Retire the HTML splash from web/index.html.
 *
 * `runApplication` is synchronous but the first paint is not, so removing it on the
 * next line would show a blank frame between the two. One rAF is enough for React to
 * have committed; the CSS class fades it out and the node is dropped after.
 */
requestAnimationFrame(() => {
  const boot = document.getElementById('boot');
  if (!boot) {
    return;
  }
  boot.classList.add('sv-boot-done');
  // Matches the 0.18s transition in the stylesheet, with a little slack.
  setTimeout(() => boot.remove(), 220);
});

registerServiceWorker();
